/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} File_Export_Ccsl_DescInputs */



/**
* | output |
* | --- |
* | "Film industry spotting list" |
*
* @param {File_Export_Ccsl_DescInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const file_export_ccsl_desc = /** @type {((inputs?: File_Export_Ccsl_DescInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<File_Export_Ccsl_DescInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Liste de reperage de l'industrie cinematographique")
	if (locale === "de") return /** @type {LocalizedString} */ ("Sichtungsliste der Filmindustrie")
	if (locale === "it") return /** @type {LocalizedString} */ ("Lista di avvistamento dell'industria cinematografica")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Список потенциальных участников киноиндустрии")
	if (locale === "es") return /** @type {LocalizedString} */ ("Lista de avistamientos de la industria cinematográfica")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("电影行业观察名单")
	if (locale === "ja") return /** @type {LocalizedString} */ ("映画業界のスポッティングリスト")
	if (locale === "hi") return /** @type {LocalizedString} */ ("फिल्म उद्योग में नज़र आने वालों की सूची")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Lista de identificação da indústria cinematográfica")
	return /** @type {LocalizedString} */ ("Film industry spotting list")
});